import { omit } from "lodash";

import LineMetricMerger, { ReportRequestBody } from "@/classes/lineMetricMerge/LineMetricMerger";
import { otherValues } from "@/settings/constants";
import { ChartDataRecord } from "@/types/charts";

export default abstract class TopNLineMerger extends LineMetricMerger {
  buildLineRequestBody(columnsBody: ReportRequestBody): ReportRequestBody {
    return omit(super.buildLineRequestBody(columnsBody), "top");
  }

  protected buildLineIndex(columnRows: ChartDataRecord[], lineRows: ChartDataRecord[]): Map<string, number> {
    const lineByKey = super.buildLineIndex(columnRows, lineRows);
    const columnKeys = this.collectColumnKeys(columnRows);
    const otherKey = [...columnKeys].find((key) => otherValues.includes(key));

    if (!otherKey) {
      return lineByKey;
    }

    // The line request carries no top, so everything the columns request folded into its
    // "other" bucket comes back as individual keys - sum them back into that bucket.
    const remainder = [...lineByKey].reduce(
      (acc, [key, value]) => (columnKeys.has(key) ? acc : acc + value),
      lineByKey.get(otherKey) ?? 0
    );

    lineByKey.set(otherKey, remainder);

    return lineByKey;
  }
}
